import React from 'react'
import UserLogin from '../components/authentication/UserLogin'
function LoginPage() {
  return (
    <div>
        <UserLogin/>
        
    </div>
    
  )
}

export default LoginPage



